export default __webpack_public_path__ + "static/media/manual14.38a8fbc1.png";